import { z } from 'zod'

import { nullableString, serverItemSchema } from '../../utils/schema'

type OneShopUser = z.infer<typeof oneshopUserSchema>

const oneshopUserSchema = serverItemSchema.extend({
  username: nullableString,
  firstName: nullableString,
  lastName: nullableString,
  account: serverItemSchema
    .extend({
      companyName: nullableString,
    })
    .nullable(),
})

export type { OneShopUser }

export { oneshopUserSchema }
